export default {
      id: "icon-abricot-usage",
      viewBox: "0 0 118.8 118.8",
      url: __webpack_public_path__ + "icons.svg#icon-abricot",
      toString: function () {
        return this.url;
      }
    }